import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, TextField, MenuItem 
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const CourseSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  description: Yup.string(),
  prerequisite: Yup.string(),
  slug: Yup.string(),
  status: Yup.string().required('Status is required')
});

export default function CourseFormDialog({ open, course, onClose, onSubmit }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Formik
        initialValues={{
          title: course?.title || '',
          description: course?.description || '',
          prerequisite: course?.prerequisite || '',
          slug: course?.slug || '',
          status: course?.status || 'draft'
        }}
        validationSchema={CourseSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <DialogTitle>Edit Course</DialogTitle>
            <DialogContent>
              <Field name="title">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Title"
                    fullWidth
                    error={touched.title && Boolean(errors.title)}
                    helperText={touched.title && errors.title}
                  />
                )}
              </Field>
              
              <Field name="description">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Description"
                    fullWidth
                    multiline
                    rows={3}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                  />
                )}
              </Field>
              
              <Field name="prerequisite">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Prerequisites"
                    fullWidth
                    error={touched.prerequisite && Boolean(errors.prerequisite)}
                    helperText={touched.prerequisite && errors.prerequisite}
                  />
                )}
              </Field>
              
              <Field name="slug">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Slug"
                    fullWidth
                    error={touched.slug && Boolean(errors.slug)}
                    helperText={touched.slug && errors.slug}
                  />
                )}
              </Field>
              
              <Field name="status">
                {({ field }) => (
                  <TextField
                    {...field}
                    select
                    margin="normal"
                    label="Status"
                    fullWidth
                    error={touched.status && Boolean(errors.status)}
                    helperText={touched.status && errors.status}
                  >
                    <MenuItem value="draft">Draft</MenuItem>
                    <MenuItem value="published">Published</MenuItem>
                    <MenuItem value="archived">Archived</MenuItem>
                  </TextField>
                )}
              </Field>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? 'Saving...' : 'Update Course'}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
